import BlogCard from "./BlogCard";
import { Link } from "react-router-dom";
import React from "react";
import content from "../../generated/content.json";
import { useLocale } from "../../i18n/LocaleProvider";
import { useT } from "../../i18n/useT";

const BlogSection = () => {
  const { lang } = useLocale();
  const t = useT();
  const posts = (content.blog?.[lang] || []).slice(0, 3);
  if (posts.length === 0) return null;
  return (
    <section className="p-3 p-lg-5 d-flex flex-column" id="blog">
      <h1 className="text-uppercase mb-4">{t("sections.blog.title")}</h1>
      <div className="row g-4">
        {posts.map((post) => (
          <div className="col-md-4" key={post.slug}>
            <BlogCard post={post} />
          </div>
        ))}
      </div>
      <div className="mt-4">
        <Link to={`/${lang}/blog`}>{t("sections.blog.viewAll")}</Link>
      </div>
    </section>
  );
};

export default BlogSection;
